const GPROG = 'g::prog::';
const GPAGES = 'g::pages::';
const GPROG_HEX = Buffer.from(GPROG).toString('hex');
const GPAGES_HEX = Buffer.from('g::pages::').toString('hex');
function getIdsFromKeys(keys, prefix) {
    return keys.map((key) => '0x' + key.toHex().slice(prefix.length));
}

export { GPAGES, GPAGES_HEX, GPROG, GPROG_HEX, getIdsFromKeys };
